import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Actions,
  selectMapIsVisible,
  selectUserPreferenceOfMap,
} from '@pass-frontend/common/offerings/data-access';
import { useStandaloneBreakpoints } from '@pass-frontend/features/standalone/data-bridge';

export interface UseMapVisibility {
  isShowingMap: boolean;
  isMapVisibleForCurrentViewport: boolean;
  isShowingMapButton: boolean;
  isMobile: boolean;
  doesUserWantToSeeMap: boolean;
  setShowMap: (visible: boolean) => void;
  toggleShowMap: () => void;
  saveUserMapPreference: (userPreference: boolean) => void;
}

export function useMapVisibility(): UseMapVisibility {
  const dispatch = useDispatch();
  const { isDesktop } = useStandaloneBreakpoints();

  const setShowMap = useCallback(
    (visible: boolean) => {
      dispatch(Actions.updateVisibilityOfMap(visible));
    },
    [dispatch],
  );

  const toggleShowMap = useCallback(() => {
    dispatch(Actions.toggleVisibilityOfMap());
  }, [dispatch]);

  const saveUserMapPreference = useCallback(
    (userPreference: boolean) => {
      dispatch(Actions.updateUserPreferenceOfMap(userPreference));
    },
    [dispatch],
  );

  const isShowingMap = useSelector(selectMapIsVisible);
  const doesUserWantToSeeMap = useSelector(selectUserPreferenceOfMap);

  const isMapVisibleForCurrentViewport = !!(isDesktop && isShowingMap);
  const isShowingMapButton = isDesktop && !isShowingMap;
  const isMobile = !isDesktop;

  return {
    isShowingMap,
    isMapVisibleForCurrentViewport,
    isShowingMapButton,
    isMobile,
    doesUserWantToSeeMap,
    setShowMap,
    toggleShowMap,
    saveUserMapPreference,
  };
}

export default useMapVisibility;
